"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _DrawingParameter_settings;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawingParameter = void 0;
const Parameter_1 = require("../Parameter");
class DrawingParameter extends Parameter_1.Parameter {
    constructor(paramDef, sessionEngineCore, parameterManager) {
        super(paramDef, sessionEngineCore, parameterManager);
        _DrawingParameter_settings.set(this, void 0);
        __classPrivateFieldSet(this, _DrawingParameter_settings, paramDef.settings, "f");
    }
    get interactionType() {
        return "drawing";
    }
    get settings() {
        return __classPrivateFieldGet(this, _DrawingParameter_settings, "f");
    }
}
exports.DrawingParameter = DrawingParameter;
_DrawingParameter_settings = new WeakMap();
//# sourceMappingURL=DrawingParameter.js.map